/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBillboard = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 22H5v-4H2V2h20v16h-3v4h-2v-4H7zM20 4H4v12h3.656l9.333-7.258L20 11zm-2.99 7.258L10.913 16H20v-2.5zM8 6a2 2 0 1 1-.001 4.001A2 2 0 0 1 8 6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBillboard as Billboard };
